import { initComponent } from './core/init-component.js'

initComponent('.js-faqs-drawer', section => { 
  const accordionItems = section.querySelectorAll('.js-accordion-item')
  
  accordionItems.forEach(item => {
    const content = item.nextElementSibling
    if (!content || !content.classList.contains('js-accordion-content')) return
      
    content.style.transition = 'all 0.3s ease-in-out'

    const plusIcon = item.querySelector('.faq-icon-plus')
    const minusIcon = item.querySelector('.faq-icon-minus')
      
    item.addEventListener('click', () => {
      const isOpen = item.classList.contains('open')
      if (isOpen) {
        content.style.height = '0'
        content.classList.remove('pt-lg')
        content.classList.remove('pb-sm')
        item.classList.remove('open')
        content.classList.remove('overflow-hidden')
        content.style.overflow = 'auto'
        if (plusIcon && minusIcon) {
          plusIcon.classList.remove('hidden')
          minusIcon.classList.add('hidden')
        }
      } else {
        content.style.height = content.scrollHeight + 24 + 'px'
        content.classList.add('pt-lg')
        content.classList.add('pb-sm')
        item.classList.add('open')
        content.style.overflow = 'hidden'
        if (plusIcon && minusIcon) {
          plusIcon.classList.add('hidden')
          minusIcon.classList.remove('hidden')
        }
      }
    })
  })

  return {
    unload() {}
  }
});